import ApiError from "../external/ensolvers-core-frontend-mui/submodules/fox-typescript/core/ApiError";

export default class ApiErrorUtils {
  public static getMessage(error: any, fallback: string): string {
    if (error instanceof ApiError) {
      return error.message || fallback;
    }
    return error?.response?.data?.message || fallback;
  }
}
